import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteLocationNormalized,
} from "vue-router";
import AdminHomeView from "../views/admin/AdminHomeView.vue";
import AdminOsszesitokView from "../views/admin/AdminOsszesitokView.vue";
import AdminIfaSummaryView from "../views/admin/AdminIfaSummaryView.vue";
import AdminMainViewWithAppBar from "../views/admin/AdminMainViewWithAppBar.vue";
import AdminLoginView from "../views/admin/AdminLoginView.vue";
import AdminAccommodationsView from "../views/admin/AdminAccommodationsView.vue";
import AdminAccommodationInquiriesView from "@/views/admin/AdminAccommodationInquiriesView.vue";
import AdminAccommodationInquiryDetailsView from "@/views/admin/AdminAccommodationInquiryDetailsView.vue";
import AdminAccommodationDetailsView from "@/views/admin/AdminAccommodationDetailsView.vue";
import AdminBookingsView from "@/views/admin/AdminBookingsView.vue";
import AdminBookingDetailsView from "@/views/admin/AdminBookingDetailsView.vue";
import AdminBillsView from "@/views/admin/AdminBillsView.vue";
import AdminBillDetailsView from "@/views/admin/AdminBillDetailsView.vue";
import AdminCompaniesView from "@/views/admin/AdminCompaniesView.vue";
import AdminCompanyDetailsView from "@/views/admin/AdminCompanyDetailsView.vue";
import RegisterView from "@/views/RegisterView.vue";
import RegisterConfirmView from "@/views/RegisterConfirmView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import PasswordResetView from "@/views/PasswordResetView.vue";
import { useAuthStore } from "@/store/AuthStore";
import axiosInstance from "@/api/axiosInstance";
import CustomerLoginView from "@/views/customer/CustomerLoginView.vue";
import CustomerMainViewWithAppBar from "@/views/customer/CustomerMainViewWithAppBar.vue";
import CustomerHomeView from "@/views/customer/CustomerHomeView.vue";
import CustomerAccommodationInquiriesView from "@/views/customer/CustomerAccommodationInquiriesView.vue";
import CustomerAccommodationInquiryDetailsView from "@/views/customer/CustomerAccommodationInquiryDetailsView.vue";
import CustomerBookingsView from "@/views/customer/CustomerBookingsView.vue";
import CustomerBookingDetailsView from "@/views/customer/CustomerBookingDetailsView.vue";
import CustomerUsersView from "@/views/customer/CustomerUsersView.vue";
import CustomerUserRegisterView from "@/views/CustomerUserRegisterView.vue";
import CustomerCostCentersView from "@/views/customer/CustomerCostCentersView.vue";
import NotFoundView from "@/views/errors/NotFoundView.vue";
import UnavailableView from "@/views/errors/UnavailableView.vue";
import PortalFrame from "@/views/errors/PortalFrame.vue";
import { classifyApiError } from "@/services/useApiError";
import {
  isRoleAllowed,
  loginPathFor,
  portalHomeFor,
} from "@/utils/routeAccess";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/admin",
    name: "home",
    meta: {
      requiresAuth: true,
      requiresRole: "ADMIN",
    },
    component: AdminMainViewWithAppBar,
    children: [
      {
        path: "",
        name: "Home",
        component: AdminHomeView,
        meta: { requiresAuth: true },
      },
      {
        path: "osszesitok",
        name: "adminosszesitok",
        component: AdminOsszesitokView,
        meta: { requiresAuth: true },
      },
      {
        path: "ifa-osszesitok",
        name: "adminifaosszesitok",
        component: AdminIfaSummaryView,
        meta: { requiresAuth: true },
      },
      {
        path: "accommodationinquiries",
        name: "adminaccommodationinquiries",
        component: AdminAccommodationInquiriesView,
        meta: { requiresAuth: true },
      },
      {
        path: "inquiry/details/:id",
        name: "admininquirydetails",
        component: AdminAccommodationInquiryDetailsView,
        meta: { requiresAuth: true },
      },
      {
        path: "accommodations",
        name: "adminaccomodations",
        component: AdminAccommodationsView,
        meta: { requiresAuth: true },
      },
      {
        path: "accommodation/details/:id",
        name: "adminaccomodationdetails",
        component: AdminAccommodationDetailsView,
        meta: { requiresAuth: true },
      },
      {
        path: "bookings",
        name: "adminbookings",
        component: AdminBookingsView,
        meta: { requiresAuth: true },
      },
      {
        path: "bookings/:id",
        name: "adminbookingdetails",
        component: AdminBookingDetailsView,
        meta: { requiresAuth: true },
      },
      {
        path: "bills",
        name: "adminbills",
        component: AdminBillsView,
        meta: { requiresAuth: true },
      },
      {
        path: "bills/:id",
        name: "adminbilldetails",
        component: AdminBillDetailsView,
        meta: { requiresAuth: true },
      },
      {
        path: "companies",
        name: "admincompanies",
        component: AdminCompaniesView,
        meta: { requiresAuth: true },
      },
      {
        path: "companies/:id",
        name: "admincompanydetails",
        component: AdminCompanyDetailsView,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/",
    component: CustomerMainViewWithAppBar,
    meta: {
      requiresAuth: true,
      requiresRole: "USER",
    },
    children: [
      {
        path: "",
        component: CustomerHomeView,
      },
      {
        path: "accommodationinquiries",
        component: CustomerAccommodationInquiriesView,
      },
      {
        path: "inquiry/details/:id",
        name: "customerinquirydetails",
        component: CustomerAccommodationInquiryDetailsView,
      },
      {
        path: "bookings",
        component: CustomerBookingsView,
      },
      {
        path: "bookings/:id",
        name: "customerbookingdetails",
        component: CustomerBookingDetailsView,
      },
      {
        path: "users",
        name: "customerusers",
        component: CustomerUsersView,
      },
      {
        path: "costcenters",
        name: "customercostcenters",
        component: CustomerCostCentersView,
      },
    ],
  },
  {
    path: "/company/register",
    name: "companyuserregister",
    component: CustomerUserRegisterView,
    meta: { requiresAuth: false },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
    meta: { requiresAuth: false },
  },
  {
    path: "/register/confirm",
    name: "registerconfirm",
    component: RegisterConfirmView,
    meta: { requiresAuth: false },
  },
  {
    path: "/forgot-password",
    name: "forgotpassword",
    component: ForgotPasswordView,
    meta: { requiresAuth: false },
  },
  {
    path: "/password-reset",
    name: "passwordreset",
    component: PasswordResetView,
    meta: { requiresAuth: false },
  },
  {
    // The single catch-all, at the root so it can hold any URL. A catch-all never outranks a
    // real route — static paths such as /login and /admin/login win on specificity regardless
    // of declaration order — so the public pages are unaffected.
    //
    // It carries no `requiresRole`: it serves whoever is signed in, and PortalFrame picks the
    // shell from their role. That is also what lets the guard render it in place of a route
    // belonging to the other portal, at the URL the user actually asked for.
    path: "/:pathMatch(.*)*",
    component: PortalFrame,
    meta: { requiresAuth: true },
    children: [{ path: "", name: "notfound", component: NotFoundView }],
  },
  {
    // The one route-level error page: reached when the guard cannot establish who the user is,
    // which is the only failure with no view already on screen to render it in place.
    path: "/hiba/nem-elerheto",
    name: "unavailable",
    component: UnavailableView,
    meta: { requiresAuth: false },
  },
  {
    path: "/admin/login",
    name: "adminlogin",
    component: AdminLoginView,
    meta: { requiresAuth: false },
  },
  {
    path: "/login",
    name: "customerlogin",
    component: CustomerLoginView,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

/**
 * The catch-all, addressed at the URL the caller actually asked for. Naming the route and
 * handing it the path segments rebuilds that exact URL, which a plain redirect would discard.
 */
const notFoundLocation = (to: RouteLocationNormalized) => ({
  name: "notfound",
  params: { pathMatch: to.path.slice(1).split("/") },
  query: to.query,
  hash: to.hash,
});

const fetchUserRole = async () => {
  const authStore = useAuthStore();
  try {
    const response = await axiosInstance.get("/api/v1/user/role");
    authStore.role = response.data.role;
    authStore.firstName = response.data.firstName ?? "";
    authStore.lastName = response.data.lastName ?? "";
    authStore.username = response.data.username ?? "";
    console.log("logged in as " + authStore.role);
  } catch (error) {
    console.error("Failed to fetch user role:", error);
    authStore.role = "";
    authStore.firstName = "";
    authStore.lastName = "";
    authStore.username = "";
    // Rethrown as-is: the guard has to tell "not signed in" from "backend is down", and a
    // flattened Error would leave it guessing — which is how a 500 used to log people out.
    throw error;
  }
};

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  if (to.meta.requiresAuth) {
    try {
      await fetchUserRole();
    } catch (error) {
      console.error(error);
      // Only an unreachable backend goes to the error page — logging someone out over a
      // hiccup is both wrong and unrecoverable, since signing in again hits the same dead
      // backend. Everything else means we could not establish a session, so: login. Note this
      // deliberately covers 403 too. /api/v1/user/role is granted to all three roles, so a 403
      // there can only mean "no usable session", and Spring Security answered anonymous
      // callers with 403 rather than 401 until an explicit entry point was configured.
      if (classifyApiError(error).kind === "unavailable") {
        return next({
          path: "/hiba/nem-elerheto",
          query: { redirect: to.fullPath },
        });
      }
      // No "your session expired" here, unlike the interceptor: arriving at a protected URL
      // with no valid cookie looks the same whether the session ran out or the user never had
      // one, and telling a first-time visitor their session expired is worse than saying nothing.
      return next({
        path: loginPathFor(to.meta.requiresRole, to.path),
        query: { redirect: to.fullPath },
      });
    }
    if (!isRoleAllowed(to.meta.requiresRole, authStore.role)) {
      const home = portalHomeFor(authStore.role);
      if (!home) {
        // A role we cannot place has no portal to fall back to, and sending it into one would
        // bounce between two routes that both reject it.
        return next({
          path: loginPathFor(to.meta.requiresRole, to.path),
          query: { redirect: to.fullPath },
        });
      }
      // "/" is the app's front door rather than a customer URL, so an admin who lands there is
      // sent to their own dashboard instead of being told it does not exist.
      if (to.path === "/") {
        return next(home);
      }
      // Everything else renders not-found where it stands. The other portal does not exist for
      // this user in any sense they can act on, so "not found" is the honest answer: a 403
      // would promise access they can ask for, which is true of a cost centre and false of a
      // whole portal. Keeping the URL follows the same rule as the resource errors — it stays
      // reloadable, bookmarkable and quotable to support.
      return next(notFoundLocation(to));
    }

    return next();
  } else {
    next();
  }
});

export default router;
